module.exports = __webpack_public_path__ + "static/media/radio_checked_mobile.f215740b.svg";